import { Component, computed, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {
  CrudbarNavComponent,
  entityState,
  jkBaseForm,
  JkEntityV2,
  JkTableService,
} from 'jk-service';
import { jkSingleComponent } from './jkSingle';

@Component({
  template: '',
  standalone: true,
  imports: [
    // Add necessary imports here when converting template
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    // Host bindings will be added here if needed
  },
})
// export class JkSingleTableComponent extends jkBaseForm implements OnInit {
export class JkSingleTableComponent
  extends jkSingleComponent
  implements OnInit {
  tableSrv!: JkTableService; // = new JkTableService();// 目前沒有使用

  constructor() {
    super();
  }
  override async ngAfterViewInit() {
    await super.ngAfterViewInit();
    setTimeout(() => {
      if (this.matSort) {
        // matTable // 目前沒有使用
        if (this.tableSrv) {
          this.tableSrv.displayedColumns = this.tableDisplayedColumns;
          const paginatorInstance = this.paginator();
          const matSortInstance = this.matSort();
          this.tableSrv.init(
            this.srv,
            paginatorInstance,
            matSortInstance
          );
        }
      } else {
        // agGrid
        //if(this.masterSrv)  // 20250728 remark
        //  this.srv.loadData(); 20250829 移到 constructor
      }
    }, 50);
  }

  override async doRefresh(): Promise<void> {
    await super.doRefresh();
    if (this.tableSrv) {
      if (this.tableSrv && this.tableSrv.displayedColumns.length === 0) {
        this.tableSrv.displayedColumns = this.tableDisplayedColumns;
      }
      this.tableSrv.doRefresh(this.srv.itemList()); // 目前沒有使用
    }
  }
  override doUIRefresh(state: entityState, item: any): void {
    super.doUIRefresh(state, item);
    if (this.tableSrv) {
      if (this.tableSrv && this.tableSrv.displayedColumns.length === 0) {
        this.tableSrv.displayedColumns = this.tableDisplayedColumns;
      }
      this.tableSrv.doRefresh(this.srv.itemList()); // 目前沒有使用
    }
  }
  override async doUIDelete(params?: any): Promise<boolean> {
    let bool = await super.doUIDelete(params);
    if (!bool) {
      return false;
    }
    if (this.tableSrv && this.tableSrv.tableDataSource) {
      //if(params){
      this.srv.item = params;
    }

    if (this.tableSrv) this.tableSrv.doRefresh(this.srv.itemList());
    return bool;
  }

  override doComReady($e: any, comName: string): void {
    super.doComReady($e, comName);
  }
}
